export default __webpack_public_path__ + "static/media/gallery.5dd30e15.svg";